import type { CSSProperties } from "react";
import { PERSONA_STATE_ORDER, type PersonaState } from "../../api/personas";

interface PersonaStateMachineHeaderProps {
  current: PersonaState;
}

const STATE_LABELS: Record<PersonaState, string> = {
  draft: "DRAFT",
  active: "ACTIVE",
  retired: "RETIRED",
};

export function PersonaStateMachineHeader({ current }: PersonaStateMachineHeaderProps) {
  const currentIdx = PERSONA_STATE_ORDER.indexOf(current);

  return (
    <div
      style={{
        display: "flex",
        gap: 4,
        alignItems: "center",
        fontFamily: "var(--font-mono)",
        fontSize: 10,
        flexWrap: "wrap",
      }}
    >
      {PERSONA_STATE_ORDER.map((state, idx) => {
        const isCurrent = state === current;
        const isPast = currentIdx > 0 && idx < currentIdx;

        const stateStyle: CSSProperties = isCurrent
          ? {
              background: "var(--accent-subtle)",
              color: "var(--success)",
              border: "1px solid rgba(34,197,94,0.35)",
              fontWeight: 700,
            }
          : isPast
            ? {
                background: "var(--bg-tertiary)",
                color: "var(--text-muted)",
                border: "1px solid var(--border)",
                textDecoration: "line-through",
                opacity: 0.65,
              }
            : {
                background: "var(--bg-tertiary)",
                color: "var(--text-muted)",
                border: "1px solid var(--border)",
              };

        return (
          <span key={state} style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <span
              style={{
                padding: "3px 8px",
                borderRadius: 4,
                ...stateStyle,
              }}
            >
              {STATE_LABELS[state]}
            </span>
            {idx < PERSONA_STATE_ORDER.length - 1 && (
              <span style={{ color: "var(--text-muted)" }}>→</span>
            )}
          </span>
        );
      })}
    </div>
  );
}
